import React from 'react';
import { FDHeadlineText } from '@facet-wealth/design';

const MessagesLabel = () => {
  return (
    <FDHeadlineText value={'Messages'} />
  );
};

MessagesLabel.defaultProps = {};

MessagesLabel.propTypes = {};

export { MessagesLabel };
